import { Button, Col, Row } from 'antd';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { formatDateToLocalTimeZone } from '../../../utils/dateFormatter';
import { StyledCard, Title } from './style';

interface Props {
  name?: string;
  apiKey?: string;
  startDate: any;
  endDate: any;
  lastUsedAt: any;
  status?: string;
  onDeactivate: Function;
  onCancel: Function;
}

const DeactivateAPIKeyInstanceForm = ({
  name,
  apiKey,
  lastUsedAt,
  startDate,
  endDate,
  status,
  onDeactivate,
  onCancel,
}: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDeactivate = async () => {
    if (isSubmitting) {
      return;
    }

    setIsSubmitting(true);
    try {
      await onDeactivate();
    } finally {
      setIsSubmitting(false);
    }
  };

  const isCurrentlyActive = status === 'Active';
  const renderActiveAPIKeyUsage = () => {
    if (lastUsedAt) {
      return <p>This API key is currently in use</p>;
    } else {
      return <p>This API key was never used</p>;
    }
  };

  return (
    <Row justify="center">
      <Title>
        <FormattedMessage id="ApiKeys.deactivate.message" />
      </Title>

      <Row justify="center">
        {isCurrentlyActive ? (
          renderActiveAPIKeyUsage()
        ) : (
          <p>This API key was set to be activated in the future</p>
        )}
      </Row>

      <Col span={24}>
        <StyledCard>
          <Row>
            <Col span={9}>
              <b>
                <FormattedMessage id="ApiKeys.form.label.keyName" />
              </b>
            </Col>
            <Col span={15}>{name || 'N/A'}</Col>
          </Row>
          <Row>
            <Col span={9}>
              <b>
                <FormattedMessage id="ApiKeys.modal.label" />
              </b>
            </Col>
            <Col span={15}>{apiKey}</Col>
          </Row>
          <Row>
            <Col span={9}>
              <b>
                <FormattedMessage id="ApiKeys.modal.label.activePeriod" />
              </b>
            </Col>
            <Col span={15}>
              {formatDateToLocalTimeZone(startDate)} -{' '}
              {formatDateToLocalTimeZone(endDate)}
            </Col>
          </Row>
        </StyledCard>
      </Col>

      <Row justify="center" gutter={[15, 0]}>
        <Col>
          <Button type="default" size="middle" onClick={() => onCancel()}>
            <FormattedMessage id="Global.cancel" />
          </Button>
        </Col>
        <Col>
          <Button
            type="primary"
            size="middle"
            onClick={handleDeactivate}
            disabled={isSubmitting}
          >
            <FormattedMessage id="Global.confirm" />
          </Button>
        </Col>
      </Row>
    </Row>
  );
};

DeactivateAPIKeyInstanceForm.defaultProps = {
  name: '',
  apiKey: '',
  status: 'Active',
};

export default DeactivateAPIKeyInstanceForm;
